// ! AUTO-GENERATED FILE
// ! DO NOT TOUCH !!!

// #pause-sonar#
import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import {
  findSupplierBySupplierNumber,
  FindSupplierBySupplierNumber$Params,
} from '../fn/supplier/find-supplier-by-supplier-number';
import { FindSupplierBySupplierNumberRestResponse } from '../models/find-supplier-by-supplier-number-rest-response';
import { StrictHttpResponse } from '../strict-http-response';

@Injectable({ providedIn: 'root' })
export class SupplierService extends BaseService {
  /** Path part for operation `findSupplierBySupplierNumber()` */
  static readonly FindSupplierBySupplierNumberPath = '/supplier/{supplierNumber}';

  /**
   * Find supplier by supplier number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findSupplierBySupplierNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSupplierBySupplierNumber$Response(
    params: FindSupplierBySupplierNumber$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<FindSupplierBySupplierNumberRestResponse>> {
    return findSupplierBySupplierNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * Find supplier by supplier number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findSupplierBySupplierNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSupplierBySupplierNumber(
    params: FindSupplierBySupplierNumber$Params,
    context?: HttpContext,
  ): Observable<FindSupplierBySupplierNumberRestResponse> {
    return this.findSupplierBySupplierNumber$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<FindSupplierBySupplierNumberRestResponse>): FindSupplierBySupplierNumberRestResponse =>
          r.body,
      ),
    );
  }
}

// #continue-sonar#
